var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timetracker"},[_c('TimeTrackerInfo',{ref:"timeTrackerInfo"}),_c('TimeTrackerWrp',{attrs:{"startFirstTimer":_vm.startFirstTimer,"stopFirstTimer":_vm.stopFirstTimer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }